import { http } from '../api/http-client';
import { BlogMeta } from '../types/blog.model';

export interface Category {
  id: string;
  name: string;
  slug: string;
  icon?: string;
  postCount: number;
}

export const getCategories = async (): Promise<Category[]> => {
  const response = await http.get('/categories');
  return response.data;
};

export const getBlogsByCategory = async (categoryId?: string, locale?: string): Promise<BlogMeta[]> => {
  const params: Record<string, string> = {};
  if (categoryId) params.categoryId = categoryId;
  if (locale) params.locale = locale;
  const response = await http.get('/blogs', { params });
  return response.data;
};
